import { render } from "./session-buttons.vue?vue&type=template&id=70caf86b&scoped=true"
import script from "./session-buttons.vue?vue&type=script&lang=js"
export * from "./session-buttons.vue?vue&type=script&lang=js"

import "./session-buttons.vue?vue&type=style&index=0&id=70caf86b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70caf86b"]])

export default __exports__